import {
  CreateCdfParams,
  RawCdfEntry,
} from 'features/dataLayers/customCdfs/cdfGenerator'
import { useGetCustomCdfUpsertDeleteFns } from 'features/dataLayers/customCdfs/useGetCustomCdfUpsertDeleteFns'
import { RolodexCacheInstance } from 'features/rolodex'
import { useEffect, useId, useMemo, useState } from 'react'

export function useCreateCustomCdf(
  args: CreateCdfParams | null,
  rolodexCacheInstance: RolodexCacheInstance,
  customId: string | null = null
) {
  const reactId = useId()

  const { createCdfFn, tearDownCdfFn } =
    useGetCustomCdfUpsertDeleteFns(rolodexCacheInstance)

  const [cdfCreated, setCdfCreated] = useState<RawCdfEntry | undefined>()

  const newId = customId ?? `custom-cdf-${reactId}`

  useEffect(() => {
    if (args) setCdfCreated(createCdfFn(newId, args))
    return () => {
      if (cdfCreated?.id) {
        tearDownCdfFn(cdfCreated.id)
      }
    }
  }, [args, cdfCreated?.id, createCdfFn, newId, tearDownCdfFn])

  return useMemo(() => {
    return { id: cdfCreated?.id ?? null, isLoading: !!args && !cdfCreated }
  }, [args, cdfCreated])
}
